// extracted by mini-css-extract-plugin
export default {"notification":"notification_notification__99fJZ","notificationMessage":"notification_notificationMessage__1RDqD"};